import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Saviynt from '../../ECMv6/assets/images/Logo/saviynt.svg';
import SaviyntWhite from '../../ECMv6/assets/images/Logo/saviynt-white.svg';

import './Logo.css';

const LOGOS = {
  saviynt: 'saviynt',
  saviyntWhite: 'saviyntWhite',
};

const getSVG = (kind) => {
  switch (kind) {
    case LOGOS.saviyntWhite:
      return <SaviyntWhite />;

    // Add more logos here
    default:
      return <Saviynt />;
  }
};

function Logo({ kind, className, onClick, tabIndex }) {
  const classes = classnames(
    'Logo',
    `Logo-kind--${kind}`,
    onClick && 'Logo--click',
    className
  );

  const onKeyUp = onClick ? (e) => e.key === 'Enter' && onClick() : null;

  return (
    <div
      className={classes}
      onClick={onClick}
      role='button'
      onKeyUp={onKeyUp}
      tabIndex={tabIndex ?? onClick ? 0 : null}>
      {getSVG(kind)}
    </div>
  );
}

Logo.propTypes = {
  kind: PropTypes.oneOf(Object.values(LOGOS)),
  onClick: PropTypes.func,
  className: PropTypes.string,
  /** Should be specified if onClick is provided. If onClick is provided but tabIndex is not, 0 will be used to adhere to a11y standards. */
  tabIndex: PropTypes.number,
};

Logo.defaultProps = {
  kind: 'saviynt',
  onClick: null,
  className: null,
  tabIndex: null,
};

export default Logo;
